export const BASE_URL = "https://mexico-seguro-production.herokuapp.com/";
// export const BASE_URL = "http://localhost:8080/";
export const BASE_CURP =
  "https://conectame.ddns.net/rest/api.php?m=curp&user=sistemas@mexicoseguro.org&pass=Mex23Gt21&val=";
